import { render, staticRenderFns } from "./FormSubmission.vue?vue&type=template&id=e7122e38&"
import script from "./FormSubmission.vue?vue&type=script&lang=js&"
export * from "./FormSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports